import { createContext, useContext } from 'react';
import { User } from '@/types';

/**
 * Dev-only mock user switcher context, extracted so both MockAuthProvider
 * (dynamically imported via the auth barrel) and RoleSwitcher can import it
 * statically without pulling MockAuthProvider into the static graph.
 */
export interface MockUserSwitcher {
  users: User[];
  activeUserId: string;
  switchUser: (id: string) => void;
}

export const MockSwitcherContext = createContext<MockUserSwitcher | undefined>(undefined);

export const useMockUserSwitcher = () => useContext(MockSwitcherContext);
